import angular from 'angular';

class CelectController {
  constructor($element, $document) {
    this.element = $element[0];
    this.$document = $document;
  }

  $postLink() {
    if (this.options && this.options.length) {
      this.packValueContainer();
      this.handleOptionsShowing();
      this.handleOptionsHidding();
    }
  }

  packValueContainer() {
    const valueContainer = angular.element('<div class="celect__value-container"></div>');

    const selectedOption = this.options.find(option => option.selected);
    if (selectedOption) {
      const initOption = Object.assign(selectedOption, {onInit: true});
      valueContainer.append(`<span class="celect__value">${initOption.label}</span>`);
      this.onSelect({option: initOption});
    }

    this.element.appendChild(valueContainer[0]);
  }

  handleOptionsShowing() {
    const element = this.element;
    element.addEventListener('click', ($event) => {
      const optionsContainer = element.querySelector('.celect__options-container');
      optionsContainer.className += ' celect__options-container--active';
    })
  }

  handleOptionsHidding() {
    // TODO resolve case with touchstart
    // https://github.com/HubSpot/select/blob/master/src/js/select.js#L18
    const clickEvent = 'click';
    this.$document.on(clickEvent, (event) => {
      if (!this.isOpen()) {
        return;
      }

      if (event.target === this.element ||
          this.element.contains(event.target)) {
        return;
      }

      this.closeOptions();
    });
  }

  isOpen() {
    return this.element.querySelector('.celect__options-container').className.match(/active/);
  }

  closeOptions() {
    const optionsContainer = this.element.querySelector('.celect__options-container');
    const newClassName = optionsContainer.className.replace(/\bcelect__options-container--active\b/,'')
    optionsContainer.className = newClassName.trim();
  }

  handleSelect(option, $event) {
    this.options.forEach((option) => {
      option.selected = false;
    })
    option.selected = true;
    this.element.querySelector('.celect__value').innerHTML = option.label;

    this.onSelect({option: option});

    this.closeOptions();
    $event.stopPropagation();
  }
}

CelectController.$inject = ['$element', '$document'];
export default CelectController;



// WEBPACK FOOTER //
// ./src/app/screens/engineer/components/celect/celect.controller.js